/**
 * Device Storage API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ValidValueRange } from './validValueRange';


export interface ParameterDto { 
    advanced?: boolean;
    categoryId?: string;
    coding?: string;
    description?: string;
    enumCoding?: { [key: string]: string; };
    factor?: number;
    flagCoding?: { [key: string]: string; };
    id?: string;
    identifier?: number;
    isAvailableAsUserParameter?: boolean;
    length?: number;
    name?: string;
    obsolete?: boolean;
    offset?: number;
    orderInSubcategory?: number;
    parameterType?: ParameterDto.ParameterTypeEnum;
    subcategory?: string;
    subsystemId?: string;
    subsystemIdentifier?: number;
    unit?: string;
    validValueRange?: ValidValueRange;
    value?: ParameterDto.ValueEnum;
    write?: boolean;
}
export namespace ParameterDto {
    export const ParameterTypeEnum = {
        Runtime: 'RUNTIME',
        FactoryUserConfig: 'FACTORY_USER_CONFIG'
    } as const;
    export type ParameterTypeEnum = typeof ParameterTypeEnum[keyof typeof ParameterTypeEnum];
    export const ValueEnum = {
        UnsignedInt: 'UNSIGNED_INT',
        SignedInt: 'SIGNED_INT',
        String: 'STRING',
        Float: 'FLOAT',
        Enumeration: 'ENUMERATION',
        Time: 'TIME',
        Daytime: 'DAYTIME',
        Date: 'DATE',
        DateTime: 'DATE_TIME',
        DateTimeAndUnsignedInt: 'DATE_TIME_AND_UNSIGNED_INT',
        TimeSpan: 'TIME_SPAN',
        TimeZone: 'TIME_ZONE',
        Flags: 'FLAGS',
        Version1111: 'VERSION_1_1_1_1',
        Version22: 'VERSION_2_2',
        Version211: 'VERSION_2_1_1',
        DateAndVersion111: 'DATE_AND_VERSION_1_1_1',
        Hex: 'HEX',
        HexDot: 'HEX_DOT',
        VhfPattern: 'VHF_PATTERN',
        CalibrationBias: 'CALIBRATION_BIAS',
        CalibrationMatrix: 'CALIBRATION_MATRIX',
        IpAddress: 'IP_ADDRESS',
        BandFlags: 'BAND_FLAGS',
        ListUnsignedInt4: 'LIST_UNSIGNED_INT_4',
        ListUnsignedInt2: 'LIST_UNSIGNED_INT_2',
        ListDateTimeAndHex8: 'LIST_DATE_TIME_AND_HEX_8',
        Range: 'RANGE',
        MessageMode: 'MESSAGE_MODE',
        GlobalstarEsn: 'GLOBALSTAR_ESN',
        Phone: 'PHONE'
    } as const;
    export type ValueEnum = typeof ValueEnum[keyof typeof ValueEnum];
}


export type ParameterTypeEnum = typeof ParameterDto.ParameterTypeEnum[keyof typeof ParameterDto.ParameterTypeEnum];
export type ValueEnum = typeof ParameterDto.ValueEnum[keyof typeof ParameterDto.ValueEnum];
